<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<a id="title2"><h1 class="title-acknowPage">Acknowledgements</h1>
<p class="p">I am enormously grateful to the following people for their time and effort and kind loan of photos etc, not least to my fellow author, friend and colleague, Graham Simons, for getting the book to press-ready standard and for his detailed work on maps and photographs: My thanks and sincere appreciation to Nigel McTeer, whose uncle, a man by the name of Maloney, fought at Arnhem and killed two Germans, one with a pair of scissors and one by putting sand in his mouth. Thanks are due in no small measure to The Pegasus Archive website and the Maroon Beret’s online news magazine for the wonderful collections of first-hand accounts faithfully compiled by the Association, its members and siblings of members. And to Deryk Wills, author of <em class="i">Put On Your Boots and Parachutes!</em> My other favourite books on Arnhem and ‘Market-Garden’ include <em class="i">The Longest Day</em> by Cornelius Ryan, <em class="i">A Tour of the Arnhem Battlefields</em> by Major John Waddy, <em class="i">Arnhem Lift</em> by Louis Hagen MM and of course <em class="i">Arnhem 1944: The Airborne Battle</em> by Martin Middlebrook. My sincere thanks as always to Libby, Jenny and Lesley at the 2nd Air Division Memorial Library in Norwich. And also to Jim Borrett.</p></a></div><a id="title2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781783468874_ack01.vue?2604053c